/**
 * A read through a query that another screen shares can still hold what was cached before the command that opened this
 * screen: the refetch a command waits for is cancelled by a second invalidation (a realtime hint), and the wait ends
 * on the cancelled fetch. A screen that decides from the list (for example "nothing to ask: close") decides only on a
 * read made after it opened (with `refetchOnMount: 'always'`), never on the cache.
 */
export function readSettled(q: {
  isSuccess: boolean;
  isFetchedAfterMount: boolean;
  isFetching: boolean;
}): boolean {
  return q.isSuccess && q.isFetchedAfterMount && !q.isFetching;
}
